import styles from './BadRoute.module.scss';

const BadRoute = () => {
    return <div className={styles['bad-route']}>BAD ROUTE</div>;
};

export default BadRoute;
